import { IdentityReferenceItem } from '@reg/shared/model';

/**
 * Model to a measurement unit (lbs, mm, etc)
 */
export class IdentityMeasurementUnit extends IdentityReferenceItem {
    public static get SPECIFIC_GRAVITY_ID(): string {
        return '1e9476fe-0fa7-48b7-9b40-fd0fb52ca892';
    }

    public static get LBS_ID(): string {
        return '0edf0d54-b111-4901-9630-5d94d6764bfe';
    }

    public static get KG_ID(): string {
        return 'b8a79869-483c-3876-6a4e-bb848dc21dfb';
    }

    public static createLbs(): IdentityMeasurementUnit {
        const lbs: IdentityMeasurementUnit = new IdentityMeasurementUnit();
        lbs.id = IdentityMeasurementUnit.LBS_ID;
        lbs.name = 'Pounds';
        lbs.abbreviation = 'lbs';
        return lbs;
    }

    public static createKgs(): IdentityMeasurementUnit {
        const kgs: IdentityMeasurementUnit = new IdentityMeasurementUnit();
        kgs.id = IdentityMeasurementUnit.KG_ID;
        kgs.name = 'Kilograms';
        kgs.abbreviation = 'kg';
        return kgs;
    }

    public static get INSTANCE_OF_NAME(): string {
        return 'MeasurementUnit';
    }

    constructor(id: string = null) {
        super();

        this.id = id;

        if (id === IdentityMeasurementUnit.LBS_ID) {
            const pounds: IdentityMeasurementUnit = IdentityMeasurementUnit.createLbs();
            this.name = pounds.name;
            this.abbreviation = pounds.abbreviation;
        }
        if (id === IdentityMeasurementUnit.KG_ID) {
            const kgs: IdentityMeasurementUnit = IdentityMeasurementUnit.createKgs();
            this.name = kgs.name;
            this.abbreviation = kgs.abbreviation;
        }
    }

    public clone(): IdentityMeasurementUnit {
        return <IdentityMeasurementUnit> super.clone();
    }

    public deserialize(json: Object): IdentityMeasurementUnit {
        return <IdentityMeasurementUnit> super.deserialize(json);
    }
}
